module.exports = __webpack_public_path__ + "tables/media/MaerskText-Regular.68e94449.woff2";